import type {ButtonHTMLAttributes, PropsWithChildren} from "react";
import clsx from "clsx";

export const SelectButton = ({
  children,
  selected,
  disabled,
  ...props
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> & {selected?: boolean}) => {
  return (
    <button
      {...props}
      className={clsx(
        "border border-stroke px-4 py-2 rounded-lg transition-colors duration-200",
        selected && "bg-active text-white border-active",
        disabled && "bg-indicator text-gray-400 border-indicator!",
        props.className,
      )}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
